import { render } from "./confirmTransfere.vue?vue&type=template&id=c1bd23e0&scoped=true"
import script from "./confirmTransfere.vue?vue&type=script&lang=js"
export * from "./confirmTransfere.vue?vue&type=script&lang=js"

import "./confirmTransfere.vue?vue&type=style&index=0&id=c1bd23e0&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1bd23e0"]])

export default __exports__